import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {VersionedResourceAdapter} from 'hateoas-navigator';
import {ConfirmationDialogComponent} from '../confirmation-dialog/confirmation-dialog.component';
import {ConfirmationDialogData} from '../confirmation-dialog/confirmation-dialog-data';
import {HalDocumentService} from 'hateoas-navigator';
import {MatDialog} from '@angular/material';
import {ConfirmationDialogResult} from '../confirmation-dialog/confirmation-dialog-result';

@Component({
  selector: 'app-resource-item',
  template: `<div class="mat-elevation-z4 cmp-wrapper">
  <mat-card>
    <mat-card-header>
      <mat-card-title>
        <h1 class="mat-display-1">{{getTitle()}}</h1>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <app-item-properties [properties]="resourceObject.getPropertiesAndEmbeddedResourcesAsProperties()"></app-item-properties>
    </mat-card-content>
    <mat-toolbar color="accent">
      <a mat-button routerLink=".." color="primary">Back to list</a>
      <a mat-button routerLink="edit" *ngIf="isEditEnabled()">Edit</a>
      <button mat-button color="warn" (click)="onDelete()" *ngIf="isDeleteEnabled()">Delete</button>
    </mat-toolbar>
  </mat-card>
</div>
`,
  styles: [`.cmp-wrapper{padding-top:10px}`]
})
export class ResourceItemComponent implements OnInit {

  resourceObject: VersionedResourceAdapter;

  constructor(private route: ActivatedRoute, private halDocumentService: HalDocumentService, private dialog: MatDialog,
              private router: Router) {
  }

  ngOnInit() {
    this.route.data.subscribe((data: { resourceObject: VersionedResourceAdapter }) => {
      this.resourceObject = data.resourceObject;
    });
  }

  getTitle() {
    return this.resourceObject.getDescriptor().getTitle();
  }

  onDelete() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '250px',
      data: {
        title: 'Are you sure?',
        text: 'The deletion cannot be undone.'
      } as ConfirmationDialogData
    });
    dialogRef.afterClosed().subscribe((result: ConfirmationDialogResult) => {
      if (result.confirmed) {
        this.halDocumentService.deleteResource(this.resourceObject.resourceObject, this.resourceObject.getVersion())
          .subscribe(() => {
            return this.router.navigate(['..'], {relativeTo: this.route});
          });
      }
    });
  }

  isEditEnabled() {
    return this.resourceObject.getDescriptor().getActions().isUpdateEnabled();
  }

  isDeleteEnabled() {
    return this.resourceObject.getDescriptor().getActions().isDeleteEnabled();
  }
}
